var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_cl.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_br.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "cl"
      ? _c(
          "div",
          [
            _c("div", { staticClass: "collectings-card-header" }),
            _c(
              "div",
              { staticClass: "card-item mt-6 select-content" },
              [
                _c(
                  "div",
                  {
                    staticClass: "buttons is-centered",
                    attrs: { id: "header-buttons" },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "button is-button-secondary is-rounded",
                        attrs: { id: "button-filter" },
                        on: {
                          click: function ($event) {
                            _vm.filtersModal = true
                          },
                        },
                      },
                      [_vm._m(0), _c("span", [_vm._v("Filtrar")])]
                    ),
                    _c(
                      "button",
                      {
                        staticClass:
                          "button block is-button-secondary is-rounded",
                        attrs: {
                          id: "button-excel",
                          disabled:
                            _vm.collectingsByFilters.length < 1 ||
                            !_vm.checkUserFeature(
                              "element.collectings.button.excel"
                            ),
                        },
                        on: { click: _vm.downloadExcel },
                      },
                      [_vm._m(1), _c("span", [_vm._v("Excel")])]
                    ),
                  ]
                ),
                !_vm.collectingsByFilters.length
                  ? _c(
                      "div",
                      { staticClass: "message-info has-text-centered" },
                      [
                        _c("i", {
                          staticClass:
                            "fas fa-exclamation-circle is-pulled-left",
                        }),
                        _c("div", { staticClass: "message-text" }, [
                          _c("span", [
                            _vm._v(
                              " No hay recaudaciones que cumplan con los valores introducidos en el filtro, vuelve a filtrar para obtener resultados. "
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              " Hay " +
                                _vm._s(_vm.collectingsByFilters.length) +
                                " recaudaci" +
                                _vm._s(
                                  _vm.collectingsByFilters.length !== 1
                                    ? "ones"
                                    : "ón"
                                ) +
                                " , estás viendo " +
                                _vm._s(_vm.collectingsByFilters.length) +
                                ". "
                            ),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "investor-content" },
                  _vm._l(_vm.collectingsByFilters, function (items, i) {
                    return _c(
                      "div",
                      {
                        key: i,
                        staticClass: "investor-item card-item shadowless",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "investor-item-info clearfix" },
                          [
                            _c("div", { staticClass: "text-info" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text has-text-weight-bold title-label",
                                },
                                [_vm._v(_vm._s(items.clientname))]
                              ),
                              _c("span", { staticClass: "text" }, [
                                _vm._v(
                                  "Nº de cuota: " + _vm._s(items.paymentnumber)
                                ),
                              ]),
                              _c("div", { staticClass: "text" }, [
                                _vm._v(
                                  "Vencimiento: " +
                                    _vm._s(_vm.formatDate(items.duedate))
                                ),
                              ]),
                              _c("div", { staticClass: "text" }, [
                                _vm._v(
                                  "Fecha de pago: " +
                                    _vm._s(_vm.formatDate(items.createdat))
                                ),
                              ]),
                              _c("div", { staticClass: "fees-content" }),
                              _c("div", { staticClass: "details-content" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.extended =
                                          _vm.extended !== i ? i : undefined
                                      },
                                    },
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.extended === i
                                            ? "Ocultar "
                                            : "Ver info "
                                        ),
                                      },
                                    }),
                                    _c("span", {
                                      staticClass:
                                        "fa fa-chevron-down transition-slow",
                                      class: { rotate: _vm.extended === i },
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "investor-details clearfix transition-slow",
                            class: { show: _vm.extended === i },
                          },
                          [
                            _c("div", { staticClass: "pt-5" }, [
                              _c(
                                "div",
                                { staticClass: "header-tabs" },
                                [
                                  _c(
                                    "b-tabs",
                                    {
                                      attrs: { expanded: "" },
                                      model: {
                                        value: _vm.selectedContent,
                                        callback: function ($$v) {
                                          _vm.selectedContent = $$v
                                        },
                                        expression: "selectedContent",
                                      },
                                    },
                                    _vm._l(
                                      _vm.contentButtons,
                                      function (value, content) {
                                        return _c("b-tab-item", {
                                          key: content,
                                          attrs: {
                                            id: `${value}-data`,
                                            label: _vm.$t(value),
                                            value: `${content}-data`,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "card-items-tabs" }, [
                                _vm.selectedContent === "client-data"
                                  ? _c(
                                      "div",
                                      { attrs: { id: "client-data" } },
                                      [
                                        _c("div", { staticClass: "columns" }, [
                                          _c("div", { staticClass: "column" }, [
                                            _c(
                                              "span",
                                              { staticClass: "title-label" },
                                              [_vm._v("RUT")]
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(_vm._s(items.idnumber)),
                                            ]),
                                          ]),
                                          _c("div", { staticClass: "column" }, [
                                            _c(
                                              "span",
                                              { staticClass: "title-label" },
                                              [_vm._v("Estado")]
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(_vm._s(items.status)),
                                            ]),
                                          ]),
                                          _c("div", { staticClass: "column" }, [
                                            _c(
                                              "span",
                                              { staticClass: "title-label" },
                                              [_vm._v("Inversor")]
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(_vm._s(items.investor)),
                                            ]),
                                          ]),
                                        ]),
                                        _c("div", { staticClass: "columns" }, [
                                          _c("div", { staticClass: "column" }, [
                                            _c(
                                              "span",
                                              { staticClass: "title-label" },
                                              [_vm._v("CMF")]
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(items.companyoperationid)
                                              ),
                                            ]),
                                          ]),
                                          _c("div", { staticClass: "column" }, [
                                            _c(
                                              "span",
                                              { staticClass: "title-label" },
                                              [_vm._v("N° cuenta inversor")]
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  items.investorbankaccountnumber
                                                )
                                              ),
                                            ]),
                                          ]),
                                          _c("div", { staticClass: "column" }, [
                                            _c(
                                              "span",
                                              { staticClass: "title-label" },
                                              [_vm._v("Medio pago")]
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(_vm._s(items.provider)),
                                            ]),
                                          ]),
                                        ]),
                                        _c("div", { staticClass: "columns" }, [
                                          _c("div", { staticClass: "column" }, [
                                            _c(
                                              "span",
                                              { staticClass: "title-label" },
                                              [_vm._v("Fecha pago")]
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(
                                                    items.providerat
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                          _c("div", { staticClass: "column" }, [
                                            _c(
                                              "span",
                                              { staticClass: "title-label" },
                                              [_vm._v("Fecha respuesta")]
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(
                                                    items.callbackat
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                          _c("div", { staticClass: "column" }, [
                                            _c(
                                              "span",
                                              { staticClass: "title-label" },
                                              [
                                                _vm._v(
                                                  "Fecha de entrada bancaria"
                                                ),
                                              ]
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(
                                                    items.bankentrydate
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]),
                                        _c("div", { staticClass: "columns" }, [
                                          _c("div", { staticClass: "column" }, [
                                            _c(
                                              "span",
                                              { staticClass: "title-label" },
                                              [_vm._v("Fecha de proceso")]
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(
                                                    items.processedat
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                          _c("div", { staticClass: "column" }, [
                                            _c(
                                              "span",
                                              { staticClass: "title-label" },
                                              [_vm._v("Fecha de cosignación")]
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(
                                                    items.consignedat
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                          _c("div", { staticClass: "column" }, [
                                            _c(
                                              "span",
                                              { staticClass: "title-label" },
                                              [_vm._v("Saldo insoluto")]
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    items.balance
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.selectedContent === "other-data"
                                  ? _c("div", { attrs: { id: "other-data" } }, [
                                      _c("div", { staticClass: "columns" }, [
                                        _c("div", { staticClass: "column" }, [
                                          _c(
                                            "span",
                                            { staticClass: "title-label" },
                                            [_vm._v("Interés de la cuota")]
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(_vm._s(items.interest)),
                                          ]),
                                        ]),
                                        _c("div", { staticClass: "column" }, [
                                          _c(
                                            "span",
                                            { staticClass: "title-label" },
                                            [_vm._v("Amortización de la cuota")]
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(_vm._s(items.amortization)),
                                          ]),
                                        ]),
                                        _c("div", { staticClass: "column" }, [
                                          _c(
                                            "span",
                                            { staticClass: "title-label" },
                                            [_vm._v("Monto del dividendo")]
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  items.monthlypayment
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "columns" }, [
                                        _c("div", { staticClass: "column" }, [
                                          _c(
                                            "span",
                                            { staticClass: "title-label" },
                                            [
                                              _vm._v(
                                                "Seguro de vida del deudor"
                                              ),
                                            ]
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(items.debtorlifeinsurance)
                                            ),
                                          ]),
                                        ]),
                                        _c("div", { staticClass: "column" }, [
                                          _c(
                                            "span",
                                            { staticClass: "title-label" },
                                            [
                                              _vm._v(
                                                "Seguro de vida del codeudor"
                                              ),
                                            ]
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                items.codebtorlifeinsurance
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("div", { staticClass: "column" }, [
                                          _c(
                                            "span",
                                            { staticClass: "title-label" },
                                            [_vm._v("Seguro de incendios")]
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(_vm._s(items.fireinsurance)),
                                          ]),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "columns" }, [
                                        _c("div", { staticClass: "column" }, [
                                          _c(
                                            "span",
                                            { staticClass: "title-label" },
                                            [_vm._v("Cargo por interés penal")]
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  items.lateinterest
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("div", { staticClass: "column" }, [
                                          _c(
                                            "span",
                                            { staticClass: "title-label" },
                                            [_vm._v("Cobranza de penalización")]
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  items.latecharges
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("div", { staticClass: "column" }, [
                                          _c(
                                            "span",
                                            { staticClass: "title-label" },
                                            [_vm._v("Monto total pagado")]
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  items.totalmonthlypayment
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "columns" }, [
                                        _c("div", { staticClass: "column" }, [
                                          _c(
                                            "span",
                                            { staticClass: "title-label" },
                                            [_vm._v("UF")]
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  items.secondarycurrencyfactor
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("div", { staticClass: "column" }, [
                                          _c(
                                            "span",
                                            { staticClass: "title-label" },
                                            [_vm._v("Total pagado")]
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  items.secondarycurrencytotalmonthlypayment
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c("div", { staticClass: "column" }, [
                                          _c(
                                            "span",
                                            { staticClass: "title-label" },
                                            [_vm._v("Retorno al inversionista")]
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  items.secondarycurrencyconsignedamount
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _c("CredituPagination", {
                  attrs: {
                    "page-number": _vm.paginationPage,
                    size: "is-small",
                    "documents-per-page": _vm.paginationPageLength,
                    "items-name": "Recaudaciones",
                    total: _vm.paginationTotalDocuments,
                    "range-before": 1,
                    "range-after": 1,
                    "documents-per-page-options": [5, 10, 20, 50],
                  },
                  on: {
                    "update:pageNumber": function ($event) {
                      _vm.paginationPage = $event
                    },
                    "update:page-number": function ($event) {
                      _vm.paginationPage = $event
                    },
                    "update:documentsPerPage": function ($event) {
                      _vm.paginationPageLength = $event
                    },
                    "update:documents-per-page": function ($event) {
                      _vm.paginationPageLength = $event
                    },
                  },
                }),
              ],
              1
            ),
            _c("CollectingsFiltersModal", {
              attrs: { collectings: _vm.collectings },
              on: { filter: _vm.loadCollectings },
              model: {
                value: _vm.filtersModal,
                callback: function ($$v) {
                  _vm.filtersModal = $$v
                },
                expression: "filtersModal",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-filter" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "far fa-file-excel" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }